import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

import { environment } from '../../../../environments/environment';
import { BaseComponent } from '../../../core/abstractions/base.component';
import { AuthRequestModel } from '../../../models/core/auth-request.model';
import { AuthService } from '../../../services/auth.service';
import { ErrorsService } from '../../../services/errors.service';

@Component({
    selector: 'sl-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('userInput') userInput: ElementRef<HTMLInputElement>;
    @ViewChild('passwordInput') passwordInput: ElementRef<HTMLInputElement>;

    formGroup = new FormGroup({
        userId: new FormControl(''),
        password: new FormControl('')
    });

    isEntering = false;
    isProduction = environment.production;
    users: { label: string; userId: string; password: string }[] = environment.users;

    private readonly authService = inject(AuthService);
    private readonly errorsService = inject(ErrorsService);

    constructor() {
        super();

        if (this.users.length > 0) {
            this.formGroup.patchValue(this.users[0]);
        }
    }

    ngOnInit(): void {
        const errorSub = this.errorsService.onBusinessException.subscribe(() => {
            this.isEntering = false;
            this.formGroup.patchValue({ password: '' });
            this.passwordInput.nativeElement.focus();
        });
        this.addSubscriptions(errorSub);
    }

    ngAfterViewInit(): void {
        this.userInput.nativeElement.focus();
    }

    login(): void {
        this.isEntering = true;
        this.authService.login(this.formGroup.getRawValue() as AuthRequestModel);
    }

    selectUser(change: MatSelectChange): void {
        if (!!change.value) {
            this.formGroup.patchValue({
                userId: change.value.userId,
                password: change.value.password
            });
            this.login(); // Automatically trigger login when user is selected
        }
    }
}
